import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { getHomeCourses } from '../api/api';
import CourseItem from '../components/CourseItem';

export default function Home() {
  const [courses, setCourses] = useState([]);

  const fetchCourse = async () => {
    const { data, error } = await getHomeCourses();
    if (!error) {
      setCourses(data?.data?.course);
    }
  };

  useEffect(() => {
    sessionStorage.removeItem('bookingPaymentId');
    sessionStorage.removeItem('bookingId');
    sessionStorage.removeItem('bookingDetails');
    sessionStorage.removeItem('isBookingConfirmed');
    sessionStorage.removeItem('isPaymentFree');

    fetchCourse();
  }, []);

  return (
    <>
      <Helmet>
        <title>
          {/* {t('emstellCourse')} - {t('knowledgeIsEverything')} */}
          Business and Technology Consultation and Workshops for Business Owners
          and Entrepreneurs
        </title>
      </Helmet>
      <div>
        <div className=" h-auto home-hero-section flex justify-center items-center">
          <div className="max-w-xs text-center w-full text-white mt-2 px-4">
            <div className="flex space-x-5 items-center mb-3">
              <span className="h-[1.5px] w-full block bg-white"></span>
              <span className="h-[1.5px] w-full block bg-white"></span>
            </div>
            <h2 className="text-3xl tracking-wide">{t('courses')}</h2>
            <h5 className="text-[11px] uppercase mt-3 font-medium tracking-wider">
              {t('knowledgeIsEverything')}
            </h5>
            <div className="mt-4">
              <span className="h-[1.5px] w-full block bg-white"></span>
            </div>
          </div>
        </div>
        {/* Courses */}
        <div className="max-w-5xl mx-auto px-4 grid grid-cols-1 xs:grid-cols-2 md:grid-cols-3 gap-10 mt-10 mb-10">
          {courses?.map((course, index) => {
            return <CourseItem key={index} data={course} />;
          })}
        </div>
      </div>
    </>
  );
}
